<template>
  <div>
    <div class="login_bg cloud-auth-bg"></div>
    <div class="content-box">
      <div class="login">
        <div class="result-box">
          <i :class="resultIconClass"></i>
          <div class="result-title">{{ resultTitle }}</div>
          <div class="result-desc">{{ resultMessage }}</div>
          <div v-if="showLaunchFallback && launchUrl" class="result-tip">
            若应用未自动开启，请点击下方按钮重试。应用开启后，本页面可直接关闭
          </div>
          <button class="result-button" type="button" @click="handleResultAction">
            {{ resultButtonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const LAUNCH_SESSION_KEY_PREFIX = "open_authorize_launch:";
const APP_LAUNCH_FALLBACK_DELAY_MS = 100;
const LAUNCH_URL_MAX_AGE_MS = 10 * 60 * 1000;
const LAUNCH_BUTTON_TEXT = "打开应用";
const TERMINAL_BUTTON_TEXT = "关闭此页面";

export default {
  name: "SchemeLaunch",
  data() {
    return {
      launchUrl: "",
      launchFallbackTimer: null,
      showLaunchFallback: false,
      resultTitle: "授权成功",
      resultMessage: "正在打开应用...",
      resultButtonText: LAUNCH_BUTTON_TEXT,
      isTerminal: false,
    };
  },
  computed: {
    resultIconClass() {
      return this.isTerminal
        ? "el-icon-warning-outline result-icon danger"
        : "el-icon-success result-icon success";
    },
  },
  created() {
    this.restoreLaunchUrl();

    if (!this.launchUrl) {
      this.showTerminalState(
        "授权已失效",
        "请返回应用内重新发起授权"
      );
      return;
    }

    this.openApp();
    this.launchFallbackTimer = setTimeout(() => {
      this.showLaunchFallback = true;
    }, APP_LAUNCH_FALLBACK_DELAY_MS);
  },
  beforeDestroy() {
    this.clearLaunchFallbackTimer();
  },
  methods: {
    restoreLaunchUrl() {
      const launchToken = this.$route.query.launch_token;
      if (!launchToken) {
        return;
      }

      const storageKey = `${LAUNCH_SESSION_KEY_PREFIX}${launchToken}`;
      const rawLaunchData = sessionStorage.getItem(storageKey);
      if (!rawLaunchData) {
        return;
      }

      sessionStorage.removeItem(storageKey);

      try {
        const launchData = JSON.parse(rawLaunchData);
        if (
          !launchData.url ||
          Date.now() - launchData.createdAt > LAUNCH_URL_MAX_AGE_MS
        ) {
          return;
        }

        this.launchUrl = launchData.url;
      } catch {
        this.launchUrl = "";
      }
    },
    clearLaunchFallbackTimer() {
      if (this.launchFallbackTimer) {
        clearTimeout(this.launchFallbackTimer);
        this.launchFallbackTimer = null;
      }
    },
    openApp() {
      if (!this.launchUrl) {
        return;
      }

      top.window.location.href = this.launchUrl;
    },
    showTerminalState(title, message) {
      this.clearLaunchFallbackTimer();
      this.isTerminal = true;
      this.showLaunchFallback = false;
      this.resultTitle = title;
      this.resultMessage = message;
      this.resultButtonText = TERMINAL_BUTTON_TEXT;
    },
    getPreferredReturnUrl() {
      if (!document.referrer) {
        return "";
      }

      if (document.referrer === top.window.location.href) {
        return "";
      }

      return document.referrer;
    },
    goBackToPreviousPage() {
      const returnUrl = this.getPreferredReturnUrl();
      if (returnUrl) {
        top.window.location.replace(returnUrl);
        return;
      }

      if (top.window.history.length > 1) {
        top.window.history.back();
        return;
      }

      top.window.location.replace("/");
    },
    handleResultAction() {
      if (this.launchUrl) {
        this.openApp();
        return;
      }

      window.close();
    },
  },
};
</script>

<style>
.content-box {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  top: 0;
  margin-top: -55px;
}

.content-box .login {
  position: relative;
  background-color: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(14px);
  margin: 0;
  padding: 82px 50px;
  border: 1px solid rgba(255, 255, 255, 0.68);
  border-radius: 8px;
  min-width: 280px;
}

.content-box .result-box {
  width: 230px;
  text-align: center;
}

.content-box .result-icon {
  font-size: 56px;
}

.content-box .result-icon.success {
  color: #67c23a;
}

.content-box .result-icon.danger {
  color: #e6a23c;
}

.content-box .result-title {
  margin-top: 14px;
  font-size: 22px;
  color: #303133;
  font-weight: 600;
}

.content-box .result-desc {
  margin-top: 12px;
  font-size: 14px;
  color: #606266;
  line-height: 1.7;
}

.content-box .result-tip {
  margin-top: 12px;
  line-height: 1.7;
  font-size: 12px;
  color: #909399;
}

.content-box .result-button {
  margin-top: 18px;
  min-width: 120px;
  height: 40px;
  border: none;
  border-radius: 4px;
  background: #409eff;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}

.content-box .result-button:hover {
  background: #66b1ff;
}
</style>
